import Technology from '@/components/pages/introduction/technology';

export default [
    {
        name: 'technology',
        path: '/introduction/technology',
        component: Technology
    }
];



// WEBPACK FOOTER //
// ./src/router/introduction/introduction.js